export default "__VITE_ASSET__ca61be9d__"